<template>
<!--
  三种变更类型 根据不同的数组变更 不能是三个数组
-->
  <div class="interiorzone">
    <h2 class="subheading">合作机构信息变更</h2>

    <div class="contentbox">
      <div class="content-order-listbox">
        <ul class="content-organset-list">
          <li class="hd">
            <div>序号</div>
            <div>统一社会信用代码</div>
            <div>变更类型</div>
            <div>变更内容</div>
            <div>操作</div>
          </li>
          <li v-for="(item,index) in infolist" :key='index'>
            <div>{{index+1}}</div>
            <div>{{item.organizationCode}}</div>
            <div>{{item.type|examinetype}}</div>
            <div v-if="item.type==0" class="pendingtrial"><span>公司名称：{{item.companyName}}</span><span>联系地址：{{item.companyAddr}}</span><span>法人姓名：{{item.legalName}}</span><span>身份证号码：{{item.legalCardCode}}</span></div>
            <div v-if="item.type==1" class="pendingtrial">
              <span>姓名：{{item.agentName}}</span>
              <span>身份证号：{{item.agentCardCode}}</span>
              <span>手机号：{{item.agentPhone}}</span>
              <span>联系邮箱：{{item.agentEmail}}</span>
              <span class="uploadphoto">上传授权书<input type="file" class="uplicense imga" id="id"  ref="inputer"  @change="addImga($event,1,item.authId,index)"   accept="image/png,image/jpeg,image/jpg"/>
                <i v-if="grant&&upimglist[index]==true" alt="授权书已上传" title="授权书已上传"></i>
              </span>
              </div>
            <div v-if="item.type==2" class="pendingtrial"><span>账户号：{{item.bankNumber}}</span><span>开户行：{{item.bankBranchName}}</span><span>开户行号：{{item.bankCode}}</span>
            <span class="uploadphoto">上传二维码<input type="file" class="uplicense imgb" id="id"  ref="inputer"  @change="addImga($event,2,item.authId,index)"   accept="image/png,image/jpeg,image/jpg"/><i v-if="ewmcode&&upimglist[index]==true" alt="二维码已上传" title="二维码已上传"></i></span></div>
            <div><span class="addok" @click="trialpanel(item.authId,item.type,index)">审核</span></div>
          </li>
        </ul>
        <div class="tipszzc" v-if="istrial">
          <div class="trialtips" v-if="isadopt">
            <h2>确认是否通过此机构信息？</h2>
            <span class="closetrial iconfont icon-guanbi1" @click="trialhidden()"></span>
            <dl>
              <dt @click="adopt()">通过</dt>
              <dd @click="reject()">驳回</dd>
            </dl>
          </div>
          <div class="trialtips" v-else>
            <span class="closetrial iconfont icon-guanbi1"  @click="trialhidden()"></span>
            <input type="text" class="rejectreason" v-model="reason" placeholder="请填写驳回原因" ref="inputa">
            <dl>
              <dt @click="adjudication()">确定</dt>
              <dd  @click="trialhidden()">取消</dd>
            </dl>
          </div>
        </div>
        <ul class="listpage" v-if="ifpageshow">
          <li @click="loadata(1)">首页</li> <!--这里是1-->
          <li v-for="(item,index) in pagenum" v-bind:key="index" :class="currentPage==item?'active':''"  @click="nextpage(item)">{{item}}</li>
          <li @click="loadata(total)">尾页</li><!--这里是pagenum-->
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ifpageshow:0,
      infolist:[],
      pagenum:0,
      currentPage:1,
      pageSize:10,
      ewmcode:false,
      grant:false,
      istrial:false,
      authId:0,
      isadopt:true,
      changetype:0,
      threshold:0,
      reason:'',
      upimglist:[]
    }
  },
  mounted:function() {
    this.dataload()
  },
  methods: {
    dataload(){
      this.ajax.post('/auth/channelChangeList',{bizContent:{currentPage:this.currentPage,pageSize:this.pageSize}})
      .then(
        result=>{
          if(result.data.status=="0000"){
            this.pagenum=result.data.data.pages
            this.pagenum>1?this.ifpageshow=true:this.ifpageshow=false
            this.infolist=result.data.data.listResponse
            for(let i= 0 ; i<this.infolist.length;i++){
              this.upimglist[i]=false
            }
          }
        }
      )
    },
    trialpanel(val,typenum,thid){
      this.istrial=true
      this.authId=val
      this.changetype=typenum
      this.threshold=thid
    },
    trialhidden(){
      this.istrial=false
      this.isadopt=true
    },
    reject(){
      this.isadopt=false
      setTimeout(()=>{
        this.$refs.inputa.focus()
      },1000 )
      
    },
    adjudication(){
      if(this.reason==''){
        swal({
          text: '请填写驳回理由',
          timer: 2000,
          buttons: false,
        })
      }
      else{
        this.ajax.post('/auth/inspectReject',{bizContent:{authId:this.authId,type:this.changetype,desc:this.reason}})
        .then(
          result=>{
            if(result.data.status=="0000"){
              this.infolist.splice(this.threshold,1)
              this.istrial=false
              this.isadopt=true
              swal({
                text: '信息已驳回',
                timer: 2000,
                buttons: false,
                icon: "success"                
              })
            }
            else{
              swal({
                text: result.data.message,
                timer: 2000,
                buttons: false
              })
            }
          }
        )
      }
    },
    adopt(){
      this.ajax.post('/auth/inspectAccess',{bizContent:{authId:this.authId,type:this.changetype}})
      .then(
        result=>{
          if(result.data.status=="0000"){
            this.infolist.splice(this.threshold,1)
            this.istrial=false
            this.isadopt=true
            swal({
              text: '信息已通过',
              timer: 2000,
              buttons: false,
              icon: "success"
            })
          }
          else{
            swal({
              text: result.data.message,
              timer: 2000,
              buttons: false
            })
          }
        }
      )
    },
    addImga(e,val,identity,bein){
      let file = e.target.files[0]
      let mbyte=Number(file.size)/1024/1024
      if(mbyte>2){
        swal({
          text: '图片过大，请使用小于2MB的文件！~',
          timer: 2000,
          buttons: false
        })
      }
      else{
        if(val==1){
        let param = new FormData()
        param.append('file', file, file.name)
        this.imgup1=true,
        this.imgupstyle1='imgup'
        this.upimg(param,val,identity).then(resolve=>{
          if(resolve!=""){
            swal({
              text: '授权书上传成功！',
              timer: 2000,
              buttons: false
            })
            this.upimglist[bein]=true
            this.grant=true
          }
          else{
            this.grant=false
          }
        })
      }
      else if(val==2){
        let param = new FormData()
        param.append('file', file, file.name)
        this.imgup2=true,
        this.imgupstyle2='imgup'
        this.upimg(param,val,identity).then(resolve=>{
          if(resolve!=""){
            this.ewmcode=true
            this.upimglist[bein]=true
            swal({
              text: '二维码上传成功！',
              timer: 2000,
              buttons: false
            })
          }
          else{
            this.ewmcode=false
          }
        })
      }
    }
   },
    upimg(data,val,identity){
      return this.ajax.post('upload/letterOrqrCode?authId='+identity+'&type='+val,data)
        .then(resolve => {
          if(resolve.data.status=="0000"){
            return Promise.resolve(resolve.data.data) ;
          }
          else{
            swal({
              text: resolve.data.message,
              timer: 2000,
              buttons: false
            })
            return Promise.resolve("")
          }
        }
      )
    },
  }
}
</script>

<style   scoped>
.pendingtrial span{
  display: table;
  float: left;
  margin-left:1%;
  border:1px solid #0E85EE;
  border-radius: 6px;
  padding:0 12px;
}
.pendingtrial span:last-child{
  float: right;
  margin-left:0;
}
.content-organset-list li{
  overflow: hidden;
  clear: both;
  height:52px;
}
.addok{
  display: table;
  margin:0 auto;
}
.pendingtrial span.uploadphoto{
  border:none;
  cursor: pointer;
  position: relative;
  max-width: 100px;
}
.pendingtrial span.uploadphoto:hover{
  text-decoration: underline;
  color: #0E85EE
}
.uploadphoto input.uplicense{
  width: 224px;
  height: 104px;
  position: absolute;
  top: 0;
  left: 0;
  line-height: 99999;
  opacity: 0;
  cursor: pointer;
}
.uploadphoto i{
  position: absolute;
  right:-10px;
  width:20px;
  height:20px;
  top: 10px;
  background: url('../../assets/upload.png') center top no-repeat;
  display: table;
}
.tipszzc{
  width:100%;
  height: 100%;
  height:100vh;
  position: fixed;
  left:0;
  top:0;
  bottom:0;
  right:0;
  background-color: rgba(0, 0, 0, 0.5)
}
.trialtips{
  width:360px;
  height:168px;
  background-color: #fff;
  position: absolute;
  left:50%;
  top:50%;
  margin-left:-180px;
  margin-top:-84px;
}
.trialtips h2{
  width: 100%;
  height:130px;
  line-height: 130px;
  text-align: center;
}
.trialtips dl{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: block;
  border-top:1px solid rgba(204, 204, 204, 0.5);
}
.trialtips dl dt,.trialtips dl dd{
  display: block;
  width:50%; 
  float: left;
  text-align: center;
  height:32px;
  line-height:32px;
  font-size: 14px;
  cursor: pointer;
}
.trialtips dl dt{
  width:calc( 50% - 1px );
  border-right:1px solid rgba(204, 204, 204, 0.5);
}
.trialtips dl dt:hover,.trialtips dl dd:hover{
  background: #e5f3ff;
}
.closetrial{
  position: absolute;
  right:8px;
  top:1px;
  color: #ccc;
}
.closetrial:hover{
  color: #000;
  cursor: pointer;
}
.rejectreason{
  width: 80%;
  height:32px;
  line-height: 32px;
  border-bottom: 1px solid #ccc;
  margin:35px auto;
  display: table;
  text-indent: 12px;

}
</style>


// WEBPACK FOOTER //
// src/page/partner/organset.vue